import styled from "styled-components";
import { Import } from "@styled-icons/boxicons-regular/Import";
import { FilterAlt as FilterAltFill } from "@styled-icons/boxicons-solid/FilterAlt";
import { DownArrow } from "@styled-icons/boxicons-solid/DownArrow";
import { newColors } from "constants/newColors";

export const StyledFilePage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const StyledIconWithTypography = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledFileManagementContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  padding: 1rem 1rem 0 1rem;
  box-sizing: border-box;
`;

export const StyledHeadline = styled.div`
  display: flex;
  margin-bottom: 1rem;
  column-gap: 0.5rem;
`;

export const StyledFileListWrapper = styled.div`
  min-height: 200px;
  flex-grow: 1;
`;

export const StyledMediaContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  cursor: pointer;
`;

export const StyledTableHeaderColumnContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.3rem;
  position: relative;
`;

export const StyledImportAtOnceButton = styled(Import)`
  width: 25px;
  height: 25px;
  padding: 3px;
  box-sizing: border-box;
  color: ${newColors.black};
  border-radius: 5px;
  background: white;
  border: solid 1px #e1ddd6;

  cursor: pointer;
`;

export const StyledSelect = styled.select`
  position: absolute;
  top: 2rem;
  left: 2.3rem;
  border-radius: 5px;
  height: fit-content;
  padding: 0.3rem;
  box-sizing: border-box;
`;

export const StyledOption = styled.option`
  cursor: pointer;
`;

export const StyledFilterAltFillButton = styled(FilterAltFill)`
  width: 25px;
  padding: 3px;
  box-sizing: border-box;
  color: ${newColors.primary};
  border-radius: 5px;
  background: white;
  border: solid 1px #e1ddd6;

  cursor: pointer;
`;

export const StyledDownArrow = styled(DownArrow)`
  width: 22px;
  height: 25px;
  padding: 3px;
  box-sizing: border-box;
  color: ${newColors.black};
  border-radius: 5px;
  background: white;
  border: solid 1px #e1ddd6;

  cursor: pointer;
`;

export const StyledImportButton = styled(Import)`
  width: 25%;
  color: ${newColors.iconGray};

  cursor: pointer;
`;
